import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "companyForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: {
                  label: "Name",
                  rules: [(v) => !!v || "Name is required"],
                  required: "",
                },
                model: {
                  value: _vm.company.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "name", $$v)
                  },
                  expression: "company.name",
                },
              }),
              _c(VTextField, {
                attrs: {
                  label: "Thai Name",
                  rules: [(v) => !!v || "Thai Name is required"],
                  required: "",
                },
                model: {
                  value: _vm.company.thaiName,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "thaiName", $$v)
                  },
                  expression: "company.thaiName",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Chinese Name", required: "" },
                model: {
                  value: _vm.company.chineseName,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "chineseName", $$v)
                  },
                  expression: "company.chineseName",
                },
              }),
              _c(VTextField, {
                attrs: {
                  label: "Website",
                  rules: [
                    (v) =>
                      !v ||
                      /^https?:\/\/[^\s/$.?#].[^\s]*$/.test(v) ||
                      "Website must be a valid URL",
                  ],
                },
                model: {
                  value: _vm.company.website,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "website", $$v)
                  },
                  expression: "company.website",
                },
              }),
              _c(VSelect, {
                attrs: {
                  items: _vm.company.relations.type,
                  "item-value": "id",
                  "item-text": "name",
                  label: "Type",
                  chips: "",
                  "deletable-chips": "",
                  rules: [(v) => !!v || "Type is required"],
                  required: "",
                },
                model: {
                  value: _vm.company.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "type", $$v)
                  },
                  expression: "company.type",
                },
              }),
              _c(VCheckbox, {
                attrs: { label: "Is This Our Own Company?" },
                model: {
                  value: _vm.company.isOwnCompany,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "isOwnCompany", $$v)
                  },
                  expression: "company.isOwnCompany",
                },
              }),
              _c(VTextField, {
                attrs: {
                  label: "Email",
                  rules: [
                    (v) => !v || /.+@.+\..+/.test(v) || "E-mail must be valid",
                  ],
                },
                model: {
                  value: _vm.company.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "email", $$v)
                  },
                  expression: "company.email",
                },
              }),
              _c(VTextarea, {
                attrs: { rows: "2", label: "Office Address (English)" },
                model: {
                  value: _vm.company.officeAddressEng,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "officeAddressEng", $$v)
                  },
                  expression: "company.officeAddressEng",
                },
              }),
              _c(VTextarea, {
                attrs: { rows: "2", label: "Office Address (Thai)" },
                model: {
                  value: _vm.company.officeAddressThai,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "officeAddressThai", $$v)
                  },
                  expression: "company.officeAddressThai",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Office Phone 1" },
                model: {
                  value: _vm.company.officePhone1,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "officePhone1", $$v)
                  },
                  expression: "company.officePhone1",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Office Phone 2" },
                model: {
                  value: _vm.company.officePhone2,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "officePhone2", $$v)
                  },
                  expression: "company.officePhone2",
                },
              }),
              _c(VTextarea, {
                attrs: { rows: "2", label: "Factory Address (English)" },
                model: {
                  value: _vm.company.factoryAddressEng,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "factoryAddressEng", $$v)
                  },
                  expression: "company.factoryAddressEng",
                },
              }),
              _c(VTextarea, {
                attrs: { rows: "2", label: "Factory Address (Thai)" },
                model: {
                  value: _vm.company.factoryAddressThai,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "factoryAddressThai", $$v)
                  },
                  expression: "company.factoryAddressThai",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Factory Phone 1" },
                model: {
                  value: _vm.company.factoryPhone1,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "factoryPhone1", $$v)
                  },
                  expression: "company.factoryPhone1",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Factory Phone 2" },
                model: {
                  value: _vm.company.factoryPhone2,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "factoryPhone2", $$v)
                  },
                  expression: "company.factoryPhone2",
                },
              }),
              _c(VTextField, {
                attrs: { label: "ISO Certifications" },
                model: {
                  value: _vm.company.isoCertifications,
                  callback: function ($$v) {
                    _vm.$set(_vm.company, "isoCertifications", $$v)
                  },
                  expression: "company.isoCertifications",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", disabled: !_vm.valid },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }